export default "__VITE_ASSET__CymGsu1C__"